import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MainComponent} from './main.component';
import {NavModule, TitleModule} from 'app/components';
import {OverviewModule, StationsModule, UserModule, HomeModule} from 'app/containers';
import {ResourcesModule} from "../../containers/resources/resources.module";
import {StartedModule} from "../../containers/get-started/started.module";
import {SharedModule} from "../../common/shared.module";
import {TranslocoModule} from "@ngneat/transloco";
import {NgCircleProgressModule} from 'ng-circle-progress';

@NgModule({
  declarations: [MainComponent],
    imports: [
        RouterModule,
        SharedModule,
        MatSidenavModule,
        NavModule,
        TitleModule,
        HomeModule,
        OverviewModule,
        StationsModule,
        ResourcesModule,
        StartedModule,
        UserModule,
        TranslocoModule,
        NgCircleProgressModule.forRoot()
    ],
  bootstrap: [MainComponent]
})
export class MainModule {
}
